export const BG_MODAL_SIZES = {
	S: 480,
	M: 800,
}
